import { Breadcrumb } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathList = location.pathname.split("/").filter((x) => x);
  console.log(pathList);

  const formatText = (text) => {
    const capitalisedText = text.charAt(0).toLocaleUpperCase() + text.slice(1).toLocaleLowerCase() 
    return capitalisedText.split("-").join(" ")
  }

  return (
    <Breadcrumb>
      <Breadcrumb.Item linkAs={Link} linkProps={{to: '/dashboard/overview'}}>Home</Breadcrumb.Item>
      {pathList.map((path, index) => (
        <Breadcrumb.Item
          linkAs={Link}
          linkProps={{
            to: `/${pathList.slice(0, index + 1).join("/")}`,
          }}
        //   active={index + 1 === pathList.length}
        >
          {formatText(path)}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
